/** Mirrors Data.DocumentCategories on the API. */
export const DOCUMENT_CATEGORIES = {
  firmApplication: 'FirmApplication',
  personApplication: 'PersonApplication',
  atpAudit: 'AtpAudit',
  atpAccreditation: 'AtpAccreditation',

  primaryInstructorDocument: 'PrimaryInstructorDocument',
  trainingDataDocument: 'TrainingDataDocument',
  constructionDataDocument: 'ConstructionDataDocument',
  courseLanguageDocument: 'CourseLanguageDocument',
  courseMaterialDocument: 'CourseMaterialDocument',
  courseTestDocument: 'CourseTestDocument',
  courseAssessmentDocument: 'CourseAssessmentDocument',
  courseQualityControlDocument: 'CourseQualityControlDocument',
  courseCertificationDocument: 'CourseCertificationDocument',
  courseFacilityDocument: 'CourseFacilityDocument',
  otherAccreditationDocument: 'OtherAccreditationDocument',

  reaccreditationInstructorListDocument: 'ReaccreditationInstructorListDocument',
  reaccreditationCourseHistoryDocument: 'ReaccreditationCourseHistoryDocument',

  preTrainingDocument: 'Pre Training Document',
  postTrainingDocument: 'Post Training Document',
  studentRoster: 'Student Roster',
  other: 'Other',

  atpExampleMaterial: 'AtpExampleMaterial',
  atpExampleTest: 'AtpExampleTest',
  atpExampleAssessment: 'AtpExampleAssessment',
  atpExampleQualityControl: 'AtpExampleQualityControl',
  atpExampleCertification: 'AtpExampleCertification'
};

export const ATP_COURSE_DOCUMENT_TYPES = [
  DOCUMENT_CATEGORIES.preTrainingDocument,
  DOCUMENT_CATEGORIES.postTrainingDocument,
  DOCUMENT_CATEGORIES.other
];
